<template>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      :color="color"
      :loader="loader"
      :width="width"
      :height="height"
      :container="container"
    />
</template>
<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'Loader',
  components: {
    Loading,
  },
  props: {
    fullPage: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    container: HTMLDivElement,
  },
  data() {
    return {
      color: '#bc204b',
      loader: 'bars',
      width: 120,
      height: 120,
    };
  },
  computed: {
    isLoading() {
      return this.loading;
    },
  },
};
</script>
